export type DeviceToken = {
  fcm: string
}

export const DeviceTokenEmpty: DeviceToken = {
  fcm: ""
}
